import { vanarChainId, vanarExplorerUrl, vanarRpcUrl, vanarChainName } from '../../utils/constants'
import { defineChain } from 'viem'

export const VanarChain = defineChain({
  id: Number(vanarChainId),
  name: vanarChainName,
  nativeCurrency: { name: 'VANRY', symbol: 'VANRY', decimals: 18 },
  rpcUrls: {
    default: { http: [vanarRpcUrl] },
    public: { http: [vanarRpcUrl] },
  },
  blockExplorers: {
    default: { name: 'VanarExplorer', url: vanarExplorerUrl },
  },
});